import { useState } from 'react';
import { useEditorContext } from '../contexts/editor';
import { useEditorEventHandler } from './useEditorEventHandler';
import { FormatChangeListenerEvent, FormatType } from '../types';

export const useToggleableFormat = (format: FormatType) => {
  const { editor } = useEditorContext();

  const getFormatStateFromEditor = () => !!editor?.formatter?.match(format);
  const [isFormatEnabled, setIsFormatEnabled] = useState(getFormatStateFromEditor());
  useEditorEventHandler(Object.values(FormatChangeListenerEvent), () =>
    // Sync React state any time editor state updates
    setIsFormatEnabled(getFormatStateFromEditor()),
  );

  const toggleFormat = () => {
    editor?.formatter?.toggle(format);
    editor?.focus();
  };

  return {
    isFormatEnabled,
    toggleFormat,
  };
};
